import { createGlobalStyle } from 'styled-components';
import landingImg from '../assets/images/masters.png';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background-color: #ffffff !important;
  }

  /* .bright.qv-panel-current-selections .wrap {
    background-color: rgba(235, 247, 234, 0.9) !important;
    border-radius: 10px 10px 0 0 !important; 
  }
  .qvt-selections, 
  .qv-panel-subtoolbar {
    border-radius: 10px !important; 
    background-color: rgba(235, 247, 234, 0.9) !important;
  } */

  .buttons.borderbox.border-bottom.border-right {
    border: 0 !important;
  }

  button.qv-subtoolbar-button {
    display: none !important;
  }

  /* .qvt-selections.qv-panel-subtoolbar.qv-panel-current-selections.ng-scope.ng-isolate-scope.bright {
    display: none !important;
  } */

  body {
    /* background: url(${landingImg}) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    -webkit-font-smoothing: antialiased;
    font-family: 'Manrope', sans-serif !important;
    padding: 0px; */
    font-family: 'Oswald', sans-serif !important;
  }

  body, input, button {

  }

  h1, h2, h3, h4, h5, h6 strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }
  
  a {
    color: #333333;
    text-decoration: none;
  }

  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter.fade-enter-active {
      opacity: 1;
      transition: opacity 300ms ease-in;
  }

  .fade-exit {
      opacity: 1;
  }

  .fade-exit.fade-exit-active {
      opacity: 0.01;
      transition: opacity 300ms ease-in;
  }
`;
